// css
import "../../scss/pages/page-guide.scss";

// npm
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// utils
import foundation from "../_utils/foundation";
foundation();

// libs
import Accordion from "../_libs/Accordion";
import ScrollObserver from "../_libs/ScrollObserver";
import HeaderSideNav from "../_libs/HeaderSideNav";
import AnchorScroll from "../_libs/AnchorScroll";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();
	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);

	// Flowセクションの画像変化
	const scrollObserver_flow = new ScrollObserver({
		target: ".js-flow-trigger",
		callback: (entry) => {
			if (entry.isIntersecting) {
				const state = entry.target.dataset.flow;
				document.body.setAttribute("data-flow-index", state);
			}
		},
		option: {
			rootMargin: "0px 0px -80% 0px",
		},
		first: 0,
	});

	// 監視開始;
	scrollObserver_flow.init();

	// faqアコーディオン

	if (window.matchMedia("(max-width: 768px)").matches) {
		Accordion({
			base: ".js-accordion",
			trigger: ".js-accordion-trigger",
			target: ".js-accordion-target",
			option: false,
		});
	}

	// アンカースクロール
	AnchorScroll(".js-anchor-scroll", 0);
});
window.addEventListener("load", () => {});
